import Application from '../Application';
import MonitorScreen from './MonitorScreen';
import Environment from './Environment';
import AudioManager from '../Audio/AudioManager';
import OfficeDesk from './OfficeDesk';
export default class World {
    constructor() {
        this.application = new Application();
        this.scene = this.application.scene;
        this.resources = this.application.resources;
        // Wait for resources
        this.resources.on('ready', () => {
            // Setup
            this.environment = new Environment();
            this.monitorScreen = new MonitorScreen();
            this.audioManager = new AudioManager();
            this.officeDesk = new OfficeDesk(this.scene, this.resources);
        });
    }
    update() {
        if (this.monitorScreen)
            this.monitorScreen.update();
        if (this.environment)
            this.environment.update();
        if (this.audioManager)
            this.audioManager.update();
    }
}
